import i18n from '@/i18n'

export default [
    {
        value: 'not_started',
        label: i18n.t('pdis.checkins.form.labels.not_started'),
        color: 'danger',
        currentValue: 0,
    },
    {
        value: 'in_progress',
        label: i18n.t('pdis.checkins.form.labels.in_progress'),
        color: 'warning',
        currentValue: 0,
    },
    {
        value: 'finished',
        label: i18n.t('pdis.checkins.form.labels.finished'),
        color: 'success',
        currentValue: 100,
    },
]
